<template>
    <div class="test-result">
        <b-icon :icon="icon" :type="iconType"/>
        <b v-if="count != null && show" class="test-result-count">{{ count }}</b>
    </div>
</template>

<script>
    const icons = {
        "0": { icon: "check", iconType: "is-success" },
        "MTR_RES_PASSED": { icon: "check", iconType: "is-success" },
        "1": { icon: "minus-circle-outline", iconType: "is-warning" },
        "MTR_RES_SKIPPED": { icon: "minus-circle-outline", iconType: "is-warning" },
        "MTR_RES_INFO": { icon: "alert-circle-outline", iconType: "is-primary" },
        default: { icon: "close", iconType: "is-danger" },
    };

    export default {
        name: "TestResult",
        props: {
            result: [Number, String],
            count: Number,
            hideIfZero: Boolean,
        },
        computed: {
            icon() {
                if (!this.show) return "";
                if (icons[this.result.toString()] == null) return icons.default.icon;
                return icons[this.result.toString()].icon;
            },
            iconType() {
                if (icons[this.result.toString()] == null) return icons.default.iconType;
                return icons[this.result.toString()].iconType;
            },
            show() {
                return !([0, "0"].includes(this.count) && this.hideIfZero);
            }
        }
    }
</script>

<style lang="scss" scoped>
    .test-result {
        position: relative;
        padding: 0.2rem;
    }

    .test-result-count {
        position: absolute;
        bottom: -0.35em;
        right: 0;
        font-size: 0.75rem;
        background-color: $warning;
        padding: 0 0.5em;
        border-radius: 50%;
    }
</style>